import { ArtifactoryDao } from '../artifactory_dao';

const {BASE_URL, API_VERSION} = window.jf

export class PipelinesPermissionsDao extends ArtifactoryDao {

    constructor($resource, RESOURCE, artifactoryNotificationsInterceptor) {
        super($resource, RESOURCE, artifactoryNotificationsInterceptor);

        this.setUrl(`${BASE_URL}${API_VERSION}${RESOURCE.PIPELINES_EFFECTIVE_PERMISSIONS}`);

        this.setCustomActions({
            'getPipelinesEffectivePermissions': {
                method: 'POST',
            }
        });
    }
}



// WEBPACK FOOTER //
// ./data/dao/pipelines_effective_permissions_dao.js